import { createLruCache } from '@/services/LruCacheService';

// Module-level LRU-ish cache of decoded image dimensions keyed by URI.
// Populated from expo-image's onLoad event so subsequent measurements
// (carousel re-entry, rotation) skip the redundant Image.getSize round-trip.
const MAX_ENTRIES = 64;
const cache = createLruCache<string, { w: number; h: number }>({ maxEntries: MAX_ENTRIES });

export const getCachedDimensions = (uri: string): { w: number; h: number } | undefined => {
  return cache.get(uri);
};

export const setCachedDimensions = (uri: string, w: number, h: number): void => {
  if (!uri || !w || !h) return;

  cache.set(uri, { w, h });
};

// URIs that have actually been *painted* in an image-viewer pane — recorded
// only from the pane <Image>'s own onLoad. This is deliberately distinct from
// the dimensions cache above, which is ALSO populated by Image.getSize()
// measurement and by the morph overlay's onLoad (both run on open for the
// active photo). Dimensions being known does NOT mean the pane has shown the
// pixels, so the pane spinner keys off this set instead: a freshly opened photo
// whose size was merely measured still shows its spinner, while a photo we have
// already painted once never flashes a spinner again on swipe/recycle.
const displayed = createLruCache<string, true>({ maxEntries: MAX_ENTRIES });

export const markUriDisplayed = (uri: string): void => {
  if (!uri) return;
  displayed.set(uri, true);
};

export const hasUriDisplayed = (uri: string): boolean => {
  return displayed.get(uri) === true;
};
